import React from 'react'
import useTranslation from '../hooks/useTranslation'

// Color palette for tags
const TAG_COLORS = [
  'bg-blue-100 text-blue-800 border-blue-200',
  'bg-green-100 text-green-800 border-green-200',
  'bg-purple-100 text-purple-800 border-purple-200',
  'bg-pink-100 text-pink-800 border-pink-200',
  'bg-yellow-100 text-yellow-800 border-yellow-200',
  'bg-indigo-100 text-indigo-800 border-indigo-200',
  'bg-red-100 text-red-800 border-red-200',
  'bg-teal-100 text-teal-800 border-teal-200',
  'bg-orange-100 text-orange-800 border-orange-200',
  'bg-cyan-100 text-cyan-800 border-cyan-200'
]

export default function TagSelector({ tags, selectedTagIds = [], onChange, locale = 'en' }) {
  const getTagColor = (tagId) => {
    const index = selectedTagIds.indexOf(tagId)
    return TAG_COLORS[index % TAG_COLORS.length]
  }

  const getTagDisplayName = (tag) => {
    const localeField = `name_${locale}`
    return tag[localeField] || tag.name_en || tag.name
  }

  const handleTagToggle = (tagId) => {
    const newSelectedIds = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter(id => id !== tagId)
      : [...selectedTagIds, tagId]
    onChange(newSelectedIds)
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Topics <span className="text-red-500">*</span>
      </label>
      
      {/* Selected Tags Display */}
      {selectedTagIds.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
          {tags
            .filter(tag => selectedTagIds.includes(tag.id))
            .map(tag => (
              <span
                key={tag.id}
                className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium border ${getTagColor(tag.id)}`}
              >
                {getTagDisplayName(tag)}
                <button
                  type="button"
                  onClick={() => handleTagToggle(tag.id)}
                  className="ml-1 hover:text-red-600 focus:outline-none"
                  aria-label="Remove tag"
                >
                  ×
                </button>
              </span>
            ))}
        </div>
      )}

      {/* Available Tags Dropdown */}
      <div className="relative">
        <select
          value=""
          onChange={(e) => {
            const tagId = parseInt(e.target.value)
            if (tagId && !selectedTagIds.includes(tagId)) {
              handleTagToggle(tagId)
            }
            e.target.value = ""
          }}
          className="block w-full rounded-md border-gray-300 shadow-sm border p-2 text-sm"
        >
          <option value="">Select a topic...</option>
          {tags
            .filter(tag => !selectedTagIds.includes(tag.id))
            .map(tag => (
              <option key={tag.id} value={tag.id}>
                {getTagDisplayName(tag)}
              </option>
            ))}
        </select>
      </div>

      {selectedTagIds.length === 0 && (
        <p className="text-sm text-red-500 mt-1">At least one topic is required</p>
      )}
    </div>
  )
}



